const DraftPromptReplacements = {
  NEXT_CHAPTER_TITLE: 'NEXT_CHAPTER_TITLE',
  NEXT_CHAPTER_NUMBER: 'NEXT_CHAPTER_NUMBER',
  CHAPTER_TITLE: 'CHAPTER_TITLE',
  CHAPTER_NUMBER: 'CHAPTER_NUMBER',
  CHAPTER_OVERVIEW: 'CHAPTER_OVERVIEW',
  PROMPT_PS_DIVIDER: 'PROMPT_POSTSCRIPT_IS_GOING_NEXT',
};

module.exports = DraftPromptReplacements;
